import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Autocomplete } from './Autocomplete';
export function AutocompleteOptionsInternal(props, ref) {
    // TODO: Refactor to much components need this state AutoComplete, TextField, Select, DatePicker
    const hasValue = Array.isArray(props.value)
        ? Boolean(props?.value[0]?.value)
        : typeof props.value === 'object'
            ? Boolean(props?.value?.value)
            : !!props.value;
    return (_jsx(Autocomplete, { ...props, ref: ref, isOptionEqualToValue: (option, value) => option.value === value?.value, getOptionLabel: (option) => {
            if (typeof option === 'string') {
                return option;
            }
            return option.label;
        }, getOptionDisabled: (option) => option?.disabled ?? false, hasValue: hasValue }));
}
export const AutocompleteOptions = React.forwardRef(AutocompleteOptionsInternal);
